import { LaytimeIntervals } from '@shared/utils/constants';
import { round } from '@shared/utils/math';

export const calculateDemurrage = (
	demurrageRate: number | null | undefined,
	timeGainedOrLost: number,
	isHour: boolean,
) => Math.abs(((demurrageRate ?? 0) / (isHour ? 1 : 24) / 60) * timeGainedOrLost);

export const calculateDespatch = (
	despatchRate: number | null | undefined,
	timeGainedOrLost: number,
	isHour: boolean,
) => ((despatchRate ?? 0) / (isHour ? 1 : 24) / 60) * timeGainedOrLost * -1;

export const dndRateUnitLabel = (interval: LaytimeIntervals | string | null | undefined): 'per hour' | 'per day' => (
	interval === LaytimeIntervals.HOUR ? 'per hour' : 'per day'
);

export const convertIntervalToDays = (
	value: number,
	interval: LaytimeIntervals | string | null | undefined,
): number => (interval === LaytimeIntervals.HOUR ? value / 24 : value);

export const convertDaysToInterval = (
	days: number,
	interval: LaytimeIntervals | string | null | undefined,
): number => (interval === LaytimeIntervals.HOUR ? days * 24 : days);

export const hoursToInterval = (
	hours: number,
	interval: LaytimeIntervals | string | null | undefined,
): number => {
	const absHours = Math.abs(hours);

	return round(interval === LaytimeIntervals.HOUR ? absHours : absHours / 24, 2);
};

export const intervalTimeUnit = (
	interval: LaytimeIntervals | string | null | undefined,
	value: number,
): string => {
	const isHour = interval === LaytimeIntervals.HOUR;
	const singular = isHour ? 'hour' : 'day';
	const plural = isHour ? 'hours' : 'days';

	return value === 1 ? singular : plural;
};
